import { useCallback } from "react";

import {
  FormatCurrencyOptions,
  formatCurrency,
} from "@whoosh/utilities/src/Currency";

import { useGetClubCurrency } from "./useGetClubCurrency";

/**
 * Returns a formatter that prefixes amounts with the club's currency symbol.
 * Values are treated as cents unless `isCents: false` is passed.
 */
export const useFormatClubCurrency = () => {
  const { currencySymbol } = useGetClubCurrency();

  return useCallback(
    (
      value: string | number | null | undefined,
      options?: FormatCurrencyOptions
    ) => formatCurrency(value, currencySymbol, options),
    [currencySymbol]
  );
};
